import { TabItem } from '../types';

interface TabHeaderProps {
    tabs: TabItem[];
}

/**
 * Render tab header buttons
 */
const TabHeader = ({ tabs }: TabHeaderProps) => (
    <>
        {tabs.map((item) => (
            <li key={item.id} className={item.id === 1 ? 'active' : ''}>
                <a href={`#${item.id}`} data-toggle="tab">
                    <h5 className="text-semibold">{item.desc}</h5>
                </a>
            </li>
        ))}
    </>
);

export default TabHeader;
